export default __webpack_public_path__ + "static/media/dashboard-search.696dd374.png";